var React = require('react');

function BurgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"1","y1":"9","x2":"25","y2":"9","stroke":"black","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"1","y1":"17","x2":"25","y2":"17","stroke":"black","strokeWidth":"2","key":1})]);
}

BurgerMenu.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = BurgerMenu;

BurgerMenu.default = BurgerMenu;
